// src/utils/generatePassword.js
// Client-side strong-password generator for the admin "genera / reset password"
// affordances. Uses window.crypto when available; ambiguous glyphs (0/O, 1/l/I)
// are dropped so a generated password is safe to read aloud / copy.
const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%&*';

export function generatePassword(length = 16) {
  let out = '';
  const cryptoObj = typeof window !== 'undefined' && (window.crypto || window.msCrypto);
  if (cryptoObj && cryptoObj.getRandomValues) {
    const arr = new Uint32Array(length);
    cryptoObj.getRandomValues(arr);
    for (let i = 0; i < length; i++) out += CHARS[arr[i] % CHARS.length];
  } else {
    for (let i = 0; i < length; i++) out += CHARS[Math.floor(Math.random() * CHARS.length)];
  }
  return out;
}
